var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_115_115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.40323 64.792H12.0231V36.614H5.40323V64.792ZM8.69948 32.9192C10.7727 32.9192 12.3959 31.3233 12.3959 29.3304C12.3959 27.3086 10.7727 25.7144 8.69948 25.7144C6.65359 25.7144 5.03198 27.3086 5.03198 29.3304C5.03198 31.3233 6.65359 32.9192 8.69948 32.9192ZM34.0602 25.7947C22.8697 25.7947 15.8513 33.4238 15.8513 45.6252C15.8513 57.8267 22.8697 65.4301 34.0602 65.4301C45.2266 65.4301 52.245 57.8283 52.245 45.6252C52.245 33.4238 45.2266 25.7931 34.0618 25.7931M34.0618 31.6399C40.8954 31.6399 45.2539 37.064 45.2539 45.622C45.2539 54.156 40.8954 59.5801 34.0634 59.5801C27.2041 59.5801 22.8713 54.1576 22.8713 45.6236C22.8713 37.064 27.2041 31.6415 34.0634 31.6415M55.0382 54.0001C55.3307 61.0715 61.1261 65.4317 69.9525 65.4317C79.2289 65.4317 85.0773 60.8594 85.0773 53.5758C85.0773 47.8592 81.7827 44.6433 73.9929 42.8626L69.5797 41.8517C64.8739 40.7363 62.9341 39.2481 62.9341 36.6944C62.9341 33.5058 65.8591 31.3779 70.1904 31.3779C74.5779 31.3779 77.5816 33.5315 77.8998 37.1202H84.4409C84.2802 30.3686 78.697 25.7963 70.245 25.7963C61.8975 25.7963 55.9688 30.3944 55.9688 37.2006C55.9688 42.6761 59.318 46.0785 66.3895 47.7001L71.3604 48.8701C76.1979 50.0127 78.165 51.6086 78.165 54.3729C78.165 57.5631 74.9491 59.8485 70.3238 59.8485C65.6454 59.8485 62.1113 57.5358 61.6838 54.0017L55.0382 54.0001Z",
    fill: "#AAAAAA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_115_115",
    x: -4,
    y: 0,
    width: 98,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.621667 0 0 0 0 0.621667 0 0 0 0 0.621667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_115_115"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_115_115",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIos);
export default __webpack_public_path__ + "static/media/ios.9e02d6d5e3a7842f9897c0fcac34e9f9.svg";
export { ForwardRef as ReactComponent };